export default "__VITE_ASSET__BVxBp6wX__"